<template>
  <div v-if="is_load">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Главная</a></li>
        <li class="breadcrumb-item active" aria-current="page">Портфолио</li>
      </ol>
    </nav>
    <section class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                    rounded></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3 text-white">Портфолио</h4>
              <p class="text-white">Тут собраны все работы,которые были выполнены  нами</p>

            </div>
          </div>

          <div class="row col-md-12 mt-3">
            <div class="card col-6"  v-for="(category,category_index) in categorys" :key="category.last_id">

              <div class="card-body">
                <h5 class="card-title">{{ category.name}}</h5>
                <router-link class="btn btn-primary" tag="a"
                             :to="{name: 'works_in_category', params: {category_id:category.last_id  }}">Посмотреть работы</router-link>

              </div>
            </div>


          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>

import Api from "../../models/Api";
import Vue from "vue";




var Avatar = require('vue-avatar');


export default {
  name: 'home',

  components: {},
  data() {
    return {
      "is_load":false,
     "categorys":[],
    }
  },
  mounted() {
  var app=this;
  Api.loadAboutcategorys_portfolio(function(data){
    //console.log('data categorys');
  //  console.log(data);
    if(data.length>0){
      app.categorys=data;
      app.is_load=true;
    }
  })
  },
  methods: {





  }
};
</script>
